<template>
    <div class="">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
                <vs-input class="w-full mt-4"
                            @keyup.enter="submitForm()"
                          type="password" label="Mot de passe actuel" placeholder="Mot de passe actuel"
                          :danger="error.old_password ? true : false"
                          :danger-text="error.old_password ? error.old_password[0] : ''"
                          v-model="input.old_password"
                />
            </div>
            <div class="vx-col md:w-1/3 w-full">
                <vs-input class="w-full mt-4"
                            @keyup.enter="submitForm()"
                          type="password" label="Nouveau Mot de passe" placeholder="Nouveau Mot de passe"
                          :danger="error.password ? true : false"
                          :danger-text="error.password ? error.password[0] : ''"
                          v-model="input.password"
                />
            </div>
            <div class="vx-col md:w-1/3 w-full">
                <vs-input class="w-full mt-4"
                        @keyup.enter="submitForm()"
                          type="password" label="Confirmer le mot de passe" placeholder="Confirmer le mot de passe"
                          :danger="error.password_confirmation ? true : false"
                          :danger-text="error.password_confirmation ? error.password_confirmation[0] : ''"
                          v-model="input.password_confirmation"
                />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="submitForm">Enregistrer</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var base_self;
    const default_input = {
        old_password: '',
        password: '',
        password_confirmation: ''
    }
    export default {
        data() {
            return {
                error: [],
                input: {
                    old_password: '',
                    password: '',
                    password_confirmation: ''
                }
            }
        },
        computed: {
            base () {
                return window.ProfileApp;
            },
        },
        methods: {
             submitForm() {
                 base_self.$vs.loading()
                window.GETCCMT.$http.post('/users/change-password', base_self.input)
                    .then((response) =>{
                        base_self.error = []
                        base_self.input = { ...default_input }
                        base_self.$vs.loading.close()
                        window.GETCCMT.success('Le mot de passe a été mis à jour.', response);
                    }).catch((error) =>{
                        base_self.$vs.loading.close()
                        if (error.response.status === 401){
                            window.GETCCMT.$router.push('/login')
                        }else {
                            base_self.error = error.response.data.errors
                        }
                    })
            }
        },
        created() {
            base_self = this;
            window.UserPasswordTabAccountApp = this;
        }
    }
</script>